export const THEME_FONTS = {
  BLACK_FONTS: {
    SINGLE_TONE: '#121212',
    TEXT: '#262626',
    SUB_TEXT: '#404040',
  },
  WHITE_FONTS: {
    SINGLE_TONE: '#FFFFFF',
    TEXT: '#FAFAFA',
    SUB_TEXT: '#F5F5F5',
  },
}

export const THEME_COLORS = {
  GOLD: {
    MAIN: '#CFB58F',
    SUB_COLOR: '#CFB58F',
    BG_OPACITY: 'rgba(207, 170, 143, 0.10)',
    FONT_COLOR: THEME_FONTS.BLACK_FONTS,
  },
  BLUE: {
    MAIN: '#294A80',
    SUB_COLOR: '#78B4DD',
    BG_OPACITY: 'rgba(120, 180, 221, 0.10)',
    FONT_COLOR: THEME_FONTS.WHITE_FONTS,
  },
  PURPLE: {
    MAIN: '#785278',
    SUB_COLOR: '#C1A2BF',
    BG_OPACITY: 'rgba(193, 162, 191, 0.10)',
    FONT_COLOR: THEME_FONTS.WHITE_FONTS,
  },
  SKYBLUE: {
    MAIN: '#94C7C2',
    SUB_COLOR: '#94C7C2',
    BG_OPACITY: 'rgba(148, 199, 194, 0.10)',
    FONT_COLOR: THEME_FONTS.BLACK_FONTS,
  },
  GREEN: {
    MAIN: '#54A678',
    SUB_COLOR: '#54A678',
    BG_OPACITY: 'rgba(84, 166, 120, 0.10)',
    FONT_COLOR: THEME_FONTS.WHITE_FONTS,
  },
  PINK: {
    MAIN: '#CF6BA3',
    SUB_COLOR: '#CF6BA3',
    BG_OPACITY: 'rgba(207, 107, 163, 0.10)',
    FONT_COLOR: THEME_FONTS.WHITE_FONTS,
  },
  YELLOW: {
    MAIN: '#DEC257',
    SUB_COLOR: '#DDC257',
    BG_OPACITY: 'rgba(221, 194, 87, 0.10)',
    FONT_COLOR: THEME_FONTS.BLACK_FONTS,
  },
  ORANGE: {
    MAIN: '#DB6652',
    SUB_COLOR: '#DA6651',
    BG_OPACITY: 'rgba(218, 102, 81, 0.10)',
    FONT_COLOR: THEME_FONTS.WHITE_FONTS,
  },
}
